let faqHeights = new Map();
let isMeasuring = false;
let faqRows = [];
let isInitialized = false;

function measureFAQHeights() {
    if (isMeasuring || !faqRows.length) return;
    isMeasuring = true;

    faqHeights.clear();

    const measureRow = (index) => {
        if (index >= faqRows.length) {
            isMeasuring = false;
            return;
        }

        const row = faqRows[index];
        const answer = row.querySelector('.faq-answer');
        if (!answer) {
            measureRow(index + 1);
            return;
        }

        row.classList.add('measuring');

        requestAnimationFrame(() => {
            const originalDisplay = answer.style.display;
            const originalHeight = answer.style.maxHeight;

            answer.style.display = 'block';
            answer.style.maxHeight = 'none';

            const height = answer.scrollHeight;
            faqHeights.set(index, height);

            answer.style.display = originalDisplay;
            answer.style.maxHeight = originalHeight;

            row.classList.remove('measuring');

            setTimeout(() => measureRow(index + 1), 0);
        });
    };

    measureRow(0);
}

function closeFAQ(row) {
    const answer = row.querySelector('.faq-answer');
    const arrow = row.querySelector('.faq-arrow-img');

    row.classList.remove('open');
    row.setAttribute('aria-expanded', 'false');

    if (answer) {
        answer.style.maxHeight = '0';
        answer.style.opacity = '0';
        answer.style.transform = 'scaleY(0)';
        answer.setAttribute('aria-hidden', 'true');
    }

    if (arrow) {
        arrow.style.transform = 'rotate(0deg)';
    }
}

function openFAQ(row, rowIndex) {
    const answer = row.querySelector('.faq-answer');
    const arrow = row.querySelector('.faq-arrow-img');

    row.classList.add('open');
    row.setAttribute('aria-expanded', 'true');

    if (answer) {
        const height = faqHeights.get(rowIndex) || answer.scrollHeight;
        answer.style.maxHeight = height + 'px';
        answer.style.opacity = '1';
        answer.style.transform = 'scaleY(1)';
        answer.removeAttribute('aria-hidden');
    }

    if (arrow) {
        arrow.style.transform = 'rotate(180deg)';
    }

    requestAnimationFrame(() => {
        const rect = row.getBoundingClientRect();
        if (rect.top < 100 || rect.bottom > window.innerHeight - 100) {
            row.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
            });
        }
    });
}

function handleFAQClick(row) {
    if (!row) return;

    const isOpen = row.classList.contains('open');
    const rowIndex = parseInt(row.getAttribute('data-faq-index') || 0);

    requestAnimationFrame(() => {
        if (isOpen) {
            closeFAQ(row);
        } else {
            faqRows.forEach(otherRow => {
                if (otherRow !== row && otherRow.classList.contains('open')) {
                    closeFAQ(otherRow);
                }
            });

            openFAQ(row, rowIndex);
        }
    });
}

function initFAQAccordion() {
    if (isInitialized) return;

    faqRows = Array.from(document.querySelectorAll('.faq-row'));

    if (!faqRows.length) return;

    faqRows.forEach((row, index) => {
        const answer = row.querySelector('.faq-answer');

        if (answer) {
            answer.style.maxHeight = '0';
            answer.style.opacity = '0';
            answer.style.transform = 'scaleY(0)';
            answer.style.transition = 'transform 0.3s ease, opacity 0.2s ease, max-height 0.3s ease';
        }

        row.setAttribute('role', 'button');
        row.setAttribute('tabindex', '0');
        row.setAttribute('aria-expanded', 'false');
        row.setAttribute('data-faq-index', index);

        row.addEventListener('click', function(e) {
            const target = e.target;
            const isFAQElement = target.closest('.faq-question') ||
                target.closest('.faq-number') ||
                target.closest('.faq-arrow') ||
                target === row;

            if (isFAQElement && !target.closest('a')) {
                e.preventDefault();
                handleFAQClick(row);
            }
        });

        row.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleFAQClick(row);
            }

            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                e.preventDefault();
                const currentIndex = parseInt(row.getAttribute('data-faq-index') || 0);
                let nextIndex;

                if (e.key === 'ArrowDown') {
                    nextIndex = Math.min(currentIndex + 1, faqRows.length - 1);
                } else {
                    nextIndex = Math.max(currentIndex - 1, 0);
                }

                const nextRow = faqRows[nextIndex];
                if (nextRow) {
                    nextRow.focus();
                }
            }
        });
    });

    isInitialized = true;

    setTimeout(measureFAQHeights, 100);

    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            measureFAQHeights();

            faqRows.forEach((row, index) => {
                if (row.classList.contains('open')) {
                    const answer = row.querySelector('.faq-answer');
                    if (answer) {
                        const height = faqHeights.get(index) || answer.scrollHeight;
                        answer.style.maxHeight = height + 'px';
                    }
                }
            });
        }, 300);
    });
}

function switchLanguage(selectedLang) {
    const currentPath = window.location.pathname;
    const currentSearch = window.location.search;
    const fullUrl = currentPath + currentSearch;
    const redirectUrl = `/set-language.php?lang=${selectedLang}&redirect=${encodeURIComponent(fullUrl)}`;
    window.location.href = redirectUrl;
}

function initLangSwitcher() {
    const mobileButtons = document.querySelectorAll('.lang-switcher.mobile-lang .icon-btn');

    if (mobileButtons.length > 0) {
        mobileButtons.forEach((btn) => {
            btn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                const selectedLang = this.dataset.lang;

                if (this.classList.contains('active')) {
                    return;
                }

                switchLanguage(selectedLang);
            });

            btn.addEventListener('touchend', function(e) {
                e.preventDefault();
                const selectedLang = this.dataset.lang;

                if (this.classList.contains('active')) return;

                switchLanguage(selectedLang);
            }, { passive: false });
        });
    }

    const desktopSelects = document.querySelectorAll('.lang-switcher.desktop-lang .custom-select');

    if (desktopSelects.length > 0) {
        desktopSelects.forEach(langSelect => {
            const display = langSelect.querySelector('.selected');
            const dropdown = langSelect.querySelector('.select-dropdown');
            const options = langSelect.querySelectorAll('.option');

            if (!display || !dropdown) {
                return;
            }

            display.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                desktopSelects.forEach(otherSelect => {
                    if (otherSelect !== langSelect) {
                        otherSelect.classList.remove('open');
                    }
                });

                langSelect.classList.toggle('open');
            });

            options.forEach((option) => {
                option.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    const selectedLang = this.getAttribute('data-value');

                    if (option.classList.contains('selected')) {
                        langSelect.classList.remove('open');
                        return;
                    }

                    switchLanguage(selectedLang);
                });
            });
        });

        document.addEventListener('click', function(e) {
            let clickedInsideDropdown = false;

            desktopSelects.forEach(select => {
                if (select.contains(e.target)) {
                    clickedInsideDropdown = true;
                }
            });

            if (!clickedInsideDropdown) {
                desktopSelects.forEach(select => {
                    if (select.classList.contains('open')) {
                        select.classList.remove('open');
                    }
                });
            }
        });

        desktopSelects.forEach(select => {
            select.addEventListener('click', function(e) {
                e.stopPropagation();
            });
        });
    }
}

document.addEventListener("DOMContentLoaded", function() {
    initFAQAccordion();
    initLangSwitcher();

    const toggle = document.getElementById('mobileMenuToggle');
    const nav = document.getElementById('mainNav');

    if (toggle && nav) {
        toggle.addEventListener('click', function() {
            nav.classList.toggle('active');

            if (!nav.classList.contains('active')) {
                closeAllSubmenus();
            }
        });
    }

    const hasSubmenuItems = document.querySelectorAll('.has-submenu');
    const navMenu = document.querySelector('.nav-menu');

    function closeAllSubmenus() {
        if (navMenu) {
            navMenu.classList.remove('submenu-active');
        }
        hasSubmenuItems.forEach(item => {
            item.classList.remove('open');
        });
    }

    window.closeAllSubmenus = closeAllSubmenus;

    hasSubmenuItems.forEach(item => {
        const arrow = item.querySelector('.submenu-arrow');

        if (arrow) {
            arrow.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                if (window.innerWidth <= 1200) {
                    hasSubmenuItems.forEach(otherItem => {
                        if (otherItem !== item) {
                            otherItem.classList.remove('open');
                        }
                    });

                    if (navMenu) {
                        navMenu.classList.add('submenu-active');
                    }
                    item.classList.add('open');
                }

                return false;
            });
        }
    });

    document.querySelectorAll('.submenu-back').forEach(backBtn => {
        backBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            closeAllSubmenus();
        }, true);
    });

    document.addEventListener('click', function(e) {
        if (window.innerWidth <= 1200 && nav && !nav.contains(e.target) && !toggle.contains(e.target)) {
            closeAllSubmenus();
        }
    });

    let resizeMenuTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeMenuTimeout);
        resizeMenuTimeout = setTimeout(function() {
            if (window.innerWidth > 1200) {
                if (nav) {
                    nav.classList.remove('active');
                }
                closeAllSubmenus();
            }
        }, 150);
    });

    if (window.matchMedia("(max-width: 900px)").matches) {
        const dropdown = document.querySelector('.custom-select-wrapper .custom-select-dropdown');
        const servicesMap = window.servicesMap || {};

        if (dropdown) {
            document.addEventListener('click', function(e) {
                requestAnimationFrame(() => {
                    if (!dropdown.contains(e.target)) {
                        dropdown.classList.remove('open');
                    }

                    if (e.target.classList.contains('custom-option')) {
                        const title = e.target.getAttribute('data-title');
                        const textEl = document.getElementById('custom-select-text');
                        const descEl = document.getElementById('custom-service-description');

                        if (textEl) textEl.innerText = e.target.innerText;
                        if (descEl) descEl.innerHTML = servicesMap[title] || '';

                        dropdown.classList.remove('open');

                        document.querySelectorAll('.custom-option').forEach(opt => opt.classList.remove('selected'));
                        e.target.classList.add('selected');
                    }
                });
            });
        }
    }
});

function toggleCustomSelect() {
    const dropdown = document.querySelector('.custom-select-wrapper .custom-select-dropdown');
    if (dropdown) {
        requestAnimationFrame(() => {
            dropdown.classList.toggle('open');
        });
    }
}